import styled from 'styled-components';

export const Root = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 10em;
`;
